import React, { Component } from 'react'
import PageHead from '../../components/pageHead';
import Layout from '../../components/Layout';
import '../../sass/_services-details.scss';
import '../../sass/_home.scss';
import TalkData from '../../components/talk-data';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Header from '../../components/header';

export default class index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Header name="services" />
                <PageHead title="AXLR DATA PVT LTD | Software Solutions"></PageHead>
                <Layout>

                    <div>
                        <section className="animejs-code">
                            <Container>
                                <div className="mt-sm-3 pt-sm-5">
                                    <Row>
                                        <Col className="pr-sm-0" md={7}>
                                            <div className="pl-sm-3 pt-5">
                                                <div className="">
                                                    <div className="count">03</div>
                                                    <div className="talk-content count-sd pl-3">What we do?</div>
                                                </div>
                                                <div className="big-heading pt-sm-2 get-0909">Software Engineering</div>
                                                <div className="main-content pt-sm-5">Technology can help us accomplish anything. What really matters is tech that works.</div>
                                            </div>
                                        </Col>
                                        <Col className="text-center">
                                            <video className="width-vedio" autoPlay loop playsInline muted>
                                            <source src={`${publicRuntimeConfig.staticFolder}/images/svg-vedio-software-dev.mp4`} type="video/mp4" />
                                            </video>
                                        </Col>
                                    </Row>
                                </div>
                                <br />
                                <br />
                            </Container>
                        </section>

                        <section className="" id="Mobile-App-Development">
                            <Container className="pt-sm-5">
                                <Row>
                                    <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/mobile-app.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Mobile App Development</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-15" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            If you are a business delivering a product/service to a direct consumer, 
                                            mobile is the way to go! Going mobile will help you streamline your operations, 
                                            thus creating value for the modern-age mobile users. We bring years of expertise in 
                                            mobile app development (iOS App / Android App / Hybrid App)<span class="read-more-target"> using cutting edge technologies 
                                            to help you succeed with your mobile strategy. We use agile development methodologies such as
                                             Scrum and TDD to deliver results. We rely on proven practices to minimize risk, maximize benefits,
                                              and continuously deliver projects on-time with impeccable quality and within budget.</span>
                                                </div>
                                        <label for="post-15" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">App Feasibility and Requirement Analysis</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">IOS App</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Android App</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Hybrid App</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Custom-Software-Development">
                            <Container className="mt-5 pt-5">
                                <Row>
                                <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/custom-Software.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Custom Software Development</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-16" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            Every business requires a solid software foundation. We break down your 
                                            business challenges into achievable goals, identifying opportunities for 
                                            technology to improve efficiency, reduce operational time, thus making your 
                                            workforce available <span class="read-more-target">for tackling bigger challenges at hand. We bring experience 
                                            across enterprise software development, API integration, modernizing legacy systems, 
                                            and consolidating apps built on latest technology frameworks to give you reliable, 
                                            secure and powerful software solutions</span>
                                                </div>
                                        <label for="post-16" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Feasibility and Requirement Analysis</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Application Design, Development, and Implementation</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Systems Integration</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Application Re-engineering</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Performance Tuning</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Application Migration</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Package-based implementations</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/custom-Software.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="ERP">
                            <Container className="mt-5 pt-5">
                                <Row>
                                <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/erp.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">ERP</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-17" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            ERP today has become a ubiquitous utility for every organization. However, 
                                            getting to an ERP can be quite tricky. An ERP needs to be built for a scalable 
                                            delivery model, ensuring that it fits the service orchestration model. We bring 
                                            <span class="read-more-target">rich experience of working across different verticals of several industries to formulate 
                                            the right strategy for you to ensure glitch-free implementation, thus giving you 
                                            a jumpstart on your digitization roadmap.</span>
                                                </div>
                                        <label for="post-17" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Financial Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Human Resource Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Production Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Supply Chain Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Asset Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Customer Service Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Project Management</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/erp.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="CRM">
                            <Container className="mt-5 pt-5">
                                <Row>
                                    <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/dev-group.png`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">CRM</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-18" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            Organizations need to leverage the right set of tools to identify their target audience, 
                                            understand their behavior and align their products and services to suit the taste of every 
                                            individual customer. Our teams bring the expertise of creating customer personas <span class="read-more-target">and identifying 
                                            customer journeys across several industries to help create a CRM that acts as a vibrant and 
                                            omnipresent social platform, thus delivering a seamless customer experience.</span>
                                                </div>
                                                <label for="post-18" class="read-more-trigger"></label>     
                                        </div>
                                        <div className="pt-4">
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Customer Journey</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Contact Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Lead Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Sales Forecasting</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Customer Intelligence</div>
                                                </Col>
                                            </Row>

                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="eCommerce">
                            <Container className="mt-5 pt-5">
                                <Row>
                                <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/e-commerce.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">eCommerce</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-19" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            Consumers today hold the power of what they want to buy, 
                                            and when and where they want to buy it. We have mastered the art of 
                                            creating omnichannel digital commerce solutions that enable us to provide 
                                            a seamless shopping experience to a customer, <span class="read-more-target">both online and in-store. 
                                            We identify crucial touchpoints across a customer's journey in digital 
                                            and physical stores and integrate them onto a single platform.</span>
                                                </div>
                                                <label for="post-19" class="read-more-trigger"></label>     
                                        </div>
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Custom eCommerce Application</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Magento</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">WooCommerce</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Shopify</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">PrestaShop</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/e-commerce.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="DevOps">
                            <Container className="mt-5 pt-5">
                                <Row>
                                    <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/dev-group.png`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">DevOps</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-20" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            It is essential for businesses to manoeuver dynamic business conditions swiftly. 
                                            However, some organizations may find it challenging to manage legacy systems while 
                                            navigating through business dynamics. We bring in agile application development methods 
                                            <span class="read-more-target">to develop hybrid applications that work with existing legacy systems bringing greater 
                                            speed and creativity to organizations. We bring in Continuous DevOps as an integral part 
                                            of the software delivery strategy for organizations.</span>
                                                </div>
                                                <label for="post-20" class="read-more-trigger"></label>     
                                        </div>
                                        <div className="pt-4">
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">DevOps Advisory and Consultation</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">DevOps Assessment and Design Roadmap</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Continuous Development</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Continuous Integration</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Continuous Deployment</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Cloud Architecture</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Product-Engineering">
                            <Container className="mt-5 pt-5">
                                <Row>
                                <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/e-commerce.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Product Engineering</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-21" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            With growing competition, businesses need to achieve faster time to market, 
                                            while delivering superior customer experience. We bring ideas to reality by 
                                            accomplishing complex engineering challenges, thus accelerating product development. 
                                            <span class="read-more-target">We enable product companies, startups, and internet-based businesses to embrace continuous 
                                            evolution through Agile and Scrum methodologies to give them the best of both iterative and 
                                            incremental approaches.</span>
                                                </div>
                                                <label for="post-21" class="read-more-trigger"></label>     
                                        </div>
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Product Consulting</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Product Architecture</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Product Development</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Rapid Prototyping</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">UX Design and UI Consulting</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/e-commerce.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <TalkData title={< span > Minimal and functional tech? < br /> We build that! </span>} subtitle="" />
                    </div>

                </Layout>
                <style>
                    {`
                    body{
                        overflow-x: hidden
                    }
                    .ta9990pj{
                        font-size: 30px !important;
                        font-weight: 900;
                    }
                    @media only screen and (max-width: 768px){
                        .big-heading {
                            font-size: 45px !important;
                            line-height: 55px !important;
                            padding-bottom: 25px;
                            padding-top: 35px !important;
                        }
                    }
                    `}
                </style>
            </div>
        )
    }
}
